/* Clinica Vie Et Sante - 14 Revista
   Filtro por area. Sin JS, las pildoras se ven pero todos los articulos quedan
   visibles: degradacion, no ruptura. */

class VesBlog {
  constructor(root) {
    this.pills = Array.from(root.querySelectorAll('[data-filter]'));
    this.posts = Array.from(root.querySelectorAll('[data-post]'));
    this.count = root.querySelector('[data-count]');
    if (!this.pills.length) return;
    this.pills.forEach((p) => p.addEventListener('click', () => this.filter(p)));
  }

  filter(pill) {
    const area = pill.dataset.filter;

    this.pills.forEach((p) => {
      const on = p === pill;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-pressed', String(on));
    });

    let shown = 0;
    this.posts.forEach((post, i) => {
      const match = area === 'all' || post.dataset.area === area;
      // hidden saca el articulo del arbol accesible: no queda tabulable.
      post.hidden = !match;
      if (match) shown += 1;
      // El destacado solo tiene sentido si es el primero VISIBLE: al filtrar,
      // un hueco de doble ancho en medio de la grilla se lee a error.
      post.classList.toggle('ves-blog__item--feature', match && shown === 1 && area === 'all' && i === 0);
    });

    if (this.count) {
      this.count.textContent = shown + (shown === 1 ? ' artículo' : ' artículos');
    }
  }
}

function initVesBlog() {
  document.querySelectorAll('[data-ves-blog]').forEach((el) => {
    if (el.dataset.vesInit === 'true') return;
    el.dataset.vesInit = 'true';
    new VesBlog(el);
  });
}

document.addEventListener('DOMContentLoaded', initVesBlog);
document.addEventListener('shopify:section:load', initVesBlog);
